module.exports = __webpack_public_path__ + "static/media/IMG_29302.149eed14.png";